import script from "./ApplicationsSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationsSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationsSidebar.vue?vue&type=style&index=0&id=7fa67ece&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa67ece"]])

export default __exports__